import Environment from '../Environment';
import mainService from '../mainService';

export function AddContactUs(data) {
  return mainService
    .post(Environment.contactUs, data)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}
